import React from 'react'
import SimpleReactValidator from 'simple-react-validator'
import RequiredSymbol from '../../shared/RequiredSymbol'

interface UserSubmitFormProps {
	onDataChange: Function
	data: Object
}

interface UserSubmitFormState {
	firstname: string
	lastname: string
	linkedinUrl: string
	phoneNumber: string
	email: string
	password: string
	consent: number | string
	organisationId: string
}

class UserSubmitForm extends React.Component<
	UserSubmitFormProps,
	UserSubmitFormState
> {
	validator = new SimpleReactValidator({
		autoForceUpdate: this,
		locale: 'en',
		element: (message) => (
			<p className="text-red-500 text-xs mt-1">{message}</p>
		),
	})

	constructor(props: UserSubmitFormProps) {
		super(props)
		this.state = {
			firstname: '',
			lastname: '',
			linkedinUrl: '',
			phoneNumber: '',
			email: '',
			password: '',
			consent: '',
			organisationId: '',
		}

		this.handleInputChange = this.handleInputChange.bind(this)
		this.changeParentData = this.changeParentData.bind(this)
	}

	handleInputChange(event: React.FormEvent<HTMLInputElement>) {
		const target = event.target as HTMLInputElement
		const value = target.checked ? target.checked : target.value
		const name = target.name

		this.setState(
			{
				[name]: value,
			} as Pick<UserSubmitFormState, keyof UserSubmitFormState>,
			() => this.changeParentData()
		)
	}

	changeParentData() {
		this.props.onDataChange(
			'userFormData',
			this.state,
			this.validator.allValid()
		)
	}

	componentDidMount() {
		this.setState({ ...this.state, ...this.props.data })
	}

	render() {
		return (
			<form onSubmit={this.changeParentData} className="pt-6 mb-4" noValidate>
				<div className="mb-4">
					<label htmlFor="firstname">
						<RequiredSymbol />
						Your first name
					</label>
					<input
						className="w-full"
						name="firstname"
						value={this.state.firstname}
						onChange={this.handleInputChange}
						onBlur={() => this.validator.showMessageFor('first name')}
						id="firstname"
						type="text"
						placeholder="John"
					/>
					{this.validator.message(
						'first name',
						this.state.firstname,
						'required|min:2'
					)}
				</div>
				<div className="mb-4">
					<label htmlFor="lastname">
						<RequiredSymbol />
						Your last name
					</label>
					<input
						className="w-full"
						name="lastname"
						value={this.state.lastname}
						onChange={this.handleInputChange}
						onBlur={() => this.validator.showMessageFor('last name')}
						id="lastname"
						type="text"
						placeholder="Doe"
					/>
					{this.validator.message(
						'last name',
						this.state.lastname,
						'required|min:2'
					)}
				</div>
				<div className="mb-4">
					<label htmlFor="email">
						<RequiredSymbol />
						Your email
					</label>
					<input
						className="w-full"
						name="email"
						value={this.state.email}
						onChange={this.handleInputChange}
						onBlur={() => this.validator.showMessageFor('email address')}
						id="email"
						type="email"
						placeholder="johndoe@example.com"
					/>
					{this.validator.message(
						'email address',
						this.state.email,
						'required|email'
					)}
				</div>
				<div className="mb-4">
					<label htmlFor="password">
						<RequiredSymbol />
						Your password
					</label>
					<small className="block text-gray-600">
						Must be at least 6 characters
					</small>
					<input
						className="w-full"
						name="password"
						value={this.state.password}
						onChange={this.handleInputChange}
						onBlur={() => this.validator.showMessageFor('password')}
						id="password"
						type="password"
						placeholder="Your password"
					/>
					{this.validator.message(
						'password',
						this.state.password,
						'required|min:6'
					)}
				</div>
				<div className="mb-4">
					<label htmlFor="password">
						<RequiredSymbol />
						Your phone number
					</label>
					<input
						className="w-full"
						name="phoneNumber"
						value={this.state.phoneNumber}
						onChange={this.handleInputChange}
						onBlur={() => this.validator.showMessageFor('phone number')}
						id="phoneNumber"
						type="text"
						placeholder="Your phone number"
					/>
					{this.validator.message(
						'phone number',
						this.state.phoneNumber,
						'required|min:2'
					)}
				</div>
				<div className="mb-4">
					<label htmlFor="lastname">Linkedin</label>
					<input
						className="w-full"
						name="linkedinUrl"
						value={this.state.linkedinUrl}
						onChange={this.handleInputChange}
						onBlur={() => this.validator.showMessageFor('linkedin')}
						id="linkedinUrl"
						type="text"
						placeholder="https://linkedin.com/..."
					/>
					{this.validator.message('linkedin', this.state.linkedinUrl, 'url')}
				</div>
				<div className="mb-4">
					<label className="md:w-2/3" htmlFor="consent">
						<input
							className="mr-2 leading-tight"
							type="checkbox"
							value={this.state.consent}
							onBlur={() =>
								this.validator.showMessageFor('privacy policy and terms')
							}
							onChange={this.handleInputChange}
							name="consent"
							id="consent"
						/>
						<span className="text-sm">
							<span className="font-normal">I agree with the</span>{' '}
							<a
								className="text-blue-500 hover:text-blue-600"
								href="/static/files/privacy_policy.pdf"
								target="_blank"
							>
								privacy policy
							</a>{' '}
							and the{' '}
							<a
								className="text-blue-500 hover:text-blue-600"
								href="/static/files/terms_and_conditions.pdf"
								target="_blank"
							>
								terms &amp; conditions
							</a>
						</span>
					</label>
					{this.validator.message(
						'privacy policy and terms',
						this.state.consent,
						'accepted|required'
					)}
				</div>
			</form>
		)
	}
}

export default UserSubmitForm
